globalThis.appVisitor = globalThis.appVisitor || {};
var popups = appVisitor.popups || {};

appVisitor.Popup = (function() {
  utils.include(Popup, appVisitor.modules.AnalyticsEventTrackable);

  Popup.preventAutomaticOpen = false;

  function Popup(config, $trigger, fromUrl) {
    this.config = config;
    this.active = true;
    this.$trigger = $trigger;
    this.fromUrl = fromUrl;
  }

  Popup.initPopups = function() {
    Popup.initFromPath(utils.$_GET.popup, null, true);

    $.each(popups, function(path, config) {
      if(!config.automatic_open) { return }
      if(!config.automatic_open_on_mobile && DeviceQueries.isMobileSize()) { return }
      if(!config.automatic_open_on_tablet && DeviceQueries.isTabletSize()) { return }
      if(!config.automatic_open_on_desktop && DeviceQueries.isDesktopSize()) { return }

      if (config.automatic_open_on_date_range) {
        var now = new Date();

        var start = config.automatic_open_on_date_range_start_at && new Date(config.automatic_open_on_date_range_start_at);
        var end = config.automatic_open_on_date_range_end_at && new Date(config.automatic_open_on_date_range_end_at);

        if ((start && now < start) || (end && now > end)) {
          return;
        }
      }

      var popup = new Popup(config);
      popup.init();
    });

    $('body').on('click', '.open-popup', function(e) {
      e.preventDefault();

      var $this = $(this),
          $linkText = $this.find('.inner-text'),
          path = $this.data('popup');

      if(path) {
        $this.attr('disabled', true);

        if($linkText.length) {
          $linkText.data('original-text', $linkText.text()).text($this.data('popup-loading'));
        }

        Popup.initFromPath(path, $this);
      }
    });
  }

  Popup.initFromPath = function(path, $trigger, fromUrl) {
    var config = popups[path];

    if(config) {
      if(fromUrl) {
        Popup.preventAutomaticOpen = true;
      }

      var popup = new Popup(config, $trigger, fromUrl);
      popup.init();
    }
  }

  $.extend(Popup.prototype, {
    init: function() {
      if(appVisitor.utils.$_GET("taking_screenshot") === '1') return;

      var popup = this;
      if(popup.isAutomaticOpen()) {
        var cookie = this._getCookieNeverOpenAgain();

        if((!popup.config.do_not_open_again_after_closing_once || cookie.never_open_again.indexOf(popup.config.path) == - 1) && !Popup.preventAutomaticOpen) {
          switch(this.config.automatic_open_type) {
            case 'on_scroll_to_bottom':
              $(window).scroll(function() {
                if($(window).scrollTop() + $(window).height() + 1 >= $(document).height()) {
                  popup._load();
                }
              });

              break;
            case 'on_time_spent_on_site':
              var cookie = popup._getCookieTimeSpentOnSite();

              if(cookie.already_opened.indexOf(popup.config.path) == -1) {
                var interval = setInterval(function() {
                  if(Date.now() >= cookie.visitor_arrived_at + popup.config.automatic_open_time_spent_on_site) {
                    clearInterval(interval);

                    popup._load(function() {
                      cookie.already_opened.push(popup.config.path);
                      utils.cookies.create('sb-popups-time-spent-on-site', cookie, null, cookie.expires_date)
                    });
                  }
                }, 1000);
              }

              break;
            case 'on_page_ready':
            default:
              popup._load();
          }
        }
      } else {
        popup._load();
      }
    },
    isAutomaticOpen: function() {
      return this.config && this.config.automatic_open && !this.$trigger && !this.fromUrl
    },
    render: function() {
      var popup = this;

      $('body').addClass('has-popup');

      if(this._hasCover()) {
        $('body').addClass('no-scroll');
      }

      $('#body-container').append(popup.$html);
      appVisitor.initElements(popup.$html);

      if(popup.$html.find('.popup-close-button').length) {
        if(this._hasCover()) {
          $('#body-container-inner').attr('inert', true);
          popup.$html.removeAttr('inert');
        }
        popup.$html.find('.popup-close-button').focus();
      }

      if(popup.$html.hasClass('cover-none')) { // cover-none is always position: fixed
        if(appVisitor.Router.prototype.getAdminContext().length > 0) {
          var width = $("#body-container-inner").width();
          popup.$wrapper.css({ width: width, left: 'initial', transform: 'initial' });
        }
      }

      if(appVisitor.config.lazyloadEnabled) {
        appVisitor.LazyLoader.lazyLoad({container: popup.$html[0]});
      } else {
        ImageQueries.refresh(popup.$html);
      }

      ElementQueries.refresh();
      appVisitor.Animations.init(popup.$html);
      popup._events();
      popup.$html.trigger('sb.popups.initialized');

      popup.setAnalyticsEvent(popup.analyticsEvent, function() {
        popup.sendAnalyticsEvent({
          action: popup._analyticsEventAction()
        });
      });

      var event = new Event("sb.popups.initialized");
      $("body")[0].dispatchEvent(event);
    },
    _load: function(callback) {
      var popup = this;

      var load = (function() {
        $.get(popup.config.url, function(data) {
          if(data.response && data.html) {
            var $html = $(data.html);

            popup.$html = $html;
            popup.$wrapper = popup.$html.find('.popup-wrapper');
            popup.analyticsEvent = popup.$html.find('.popup').data('analytics-events-params');

            popup.render();

            popup._resetTrigger();

            if(typeof callback == 'function') callback();
          }
        });
      });

      if(popup.active) {
        if(popup.isAutomaticOpen()) {
          popup.active = false;
        }

        if(popup.isAutomaticOpen() && popup.config.automatic_open_delay) {
          setTimeout(function() {
            load();
          }, popup.config.automatic_open_delay);
        } else {
          load();
        }
      }
    },
    _close: function() {
      var popup = this;

      $('body').removeClass('has-popup no-scroll');
      $('#body-container-inner').removeAttr('inert');

      if(popup.config.do_not_open_again_after_closing_once) {
        if(popup.isAutomaticOpen()) {
          var cookie = popup._getCookieNeverOpenAgain();

          if(cookie.never_open_again.indexOf(popup.config.path) == - 1) {
            cookie.never_open_again.push(popup.config.path);

            utils.cookies.create('sb-popups-never-open-again', cookie);
          }
        }
      }

      popup.$html.remove();

      popup.setAnalyticsEvent(popup.analyticsEvent, function() {
        popup.sendAnalyticsEvent({
          action: 'Fermeture'
        });
      });
    },
    _getCookieTimeSpentOnSite: function() {
      var cookie = utils.cookies.get('sb-popups-time-spent-on-site');

      if(!cookie) {
        utils.cookies.create('sb-popups-time-spent-on-site', {
          visitor_arrived_at: Date.now(),
          already_opened: []
        }, 1);

        cookie = utils.cookies.get('sb-popups-time-spent-on-site');
      }

      return JSON.parse(cookie);
    },
    _getCookieNeverOpenAgain: function() {
      var cookie = utils.cookies.get('sb-popups-never-open-again');

      if(!cookie) {
        utils.cookies.create('sb-popups-never-open-again', {
          never_open_again: []
        });

        cookie = utils.cookies.get('sb-popups-never-open-again');
      }

      return JSON.parse(cookie);
    },
    _resetTrigger: function() {
      if(this.$trigger) {
        var $linkText = this.$trigger.find('.inner-text');

        this.$trigger.attr('disabled', false);
        $linkText.text($linkText.data('original-text'));
      }
    },
    _events: function() {
      var popup = this;

      // Close popup when clicked outside
      if(!$('body').attr('class').match(/\badmin-context-/) && popup._hasCover()) {
        var $innerContainer = popup.$html.find(".sb-bloc-inner");

        popup.$html.on('click', function(e) {
          if ($innerContainer.length && !$innerContainer.is(e.target) && $innerContainer.has(e.target).length === 0) {
            popup._close();
          }
        });
      }

      // When a button inside a popup is clicked, this makes it act as if it was closed
      popup.$html.on('click', '.element-link', function(e) {
        var $link   = $(this).find('a');
        var href    = $link.attr('href');
        var target  = $link.attr('target');

        if(href && href != "javascript:void(0)" && href != "" && !$link.hasClass("link-open-conversion-tracking")) {
          e.preventDefault();
          popup._close();
          if(target == "_blank") {
            window.open(href);
          } else {
            window.location = href;
          }
        }
      });
      popup.$html.on('click', '.popup-close-button', function() {
        popup._close();
      });
      popup.$html.on('sb.closePopup', function() {
        popup._close();
      });
      popup.$html.on('click', '.popup-close a', function(event) {
        event.preventDefault();
        popup.$html.trigger("sb.closePopup");
        return false;
      });
    },
    _hasCover: function() {
      return this.config.cover_type && this.config.cover_type != 'none'
    },
    _analyticsEventAction: function() {
      var action = 'Ouverture';

      if(this.isAutomaticOpen()) {
        action += ' automatique (' + this.config.automatic_open_type_label + ')'
      } else if(this.$trigger) {
        action += ' manuelle';
      } else if(this.fromUrl) {
        action += ' depuis l\'URL';
      }

      return action;
    }
  });

  return Popup;
})();
